export const text = {
  street: "5551 Windhaven Pkwy, Suite 200",
  city: "Lewisville, TX 75056",
  phone: "972-480-0888",
  fax: "972-480-8884",
  email: "service@trastarusa.com",
};
